import { render, staticRenderFns } from "./mingdian.vue?vue&type=template&id=052f71d1&scoped=true&"
import script from "./mingdian.vue?vue&type=script&lang=js&"
export * from "./mingdian.vue?vue&type=script&lang=js&"
import style0 from "./mingdian.vue?vue&type=style&index=0&id=052f71d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052f71d1",
  null
  
)

export default component.exports